const CANVAS_EMOJI_FONT_STACK =
  '"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji","EmojiOne Color","Android Emoji",sans-serif';

const FLAG_FONT_NAME = "Twemoji Country Flags";
const FLAG_FONT_URL = "/assets/fonts/TwemojiCountryFlags.ttf";
const POLYFILL_STYLE_ID = "country-flag-emoji-polyfill";

let needsPolyfillCache: boolean | null = null;

function needsCountryFlagPolyfill(): boolean {
  if (needsPolyfillCache !== null) {
    return needsPolyfillCache;
  }

  if (typeof document === "undefined") {
    needsPolyfillCache = false;
    return false;
  }

  const canvas = document.createElement("canvas");
  canvas.width = canvas.height = 1;
  const context = canvas.getContext("2d", { willReadFrequently: true });
  if (!context) {
    needsPolyfillCache = false;
    return false;
  }

  context.textBaseline = "top";
  context.font = `100px ${CANVAS_EMOJI_FONT_STACK}`;
  context.scale(0.01, 0.01);

  const render = (text: string, color: string) => {
    context.clearRect(0, 0, 100, 100);
    context.fillStyle = color;
    context.fillText(text, 0, 0);
    return context.getImageData(0, 0, 1, 1).data.join(",");
  };

  const whiteEmoji = render("\u{1F60A}", "#fff");
  const blackEmoji = render("\u{1F60A}", "#000");
  const supportsColorEmoji = blackEmoji !== whiteEmoji || !blackEmoji.startsWith("0,0,0,");

  const whiteFlag = render("\u{1F1E8}\u{1F1ED}", "#fff");
  const blackFlag = render("\u{1F1E8}\u{1F1ED}", "#000");
  const supportsCountryFlags = blackFlag !== whiteFlag || !blackFlag.startsWith("0,0,0,");

  needsPolyfillCache = supportsColorEmoji && !supportsCountryFlags;
  return needsPolyfillCache;
}

export function injectCountryFlagEmojiPolyfill(targetDocument: Document = document): boolean {
  if (!needsCountryFlagPolyfill() || targetDocument.getElementById(POLYFILL_STYLE_ID)) {
    return false;
  }

  const style = targetDocument.createElement("style");
  style.id = POLYFILL_STYLE_ID;
  style.textContent = `@font-face {
    font-family: "${FLAG_FONT_NAME}";
    unicode-range: U+1F1E6-1F1FF, U+1F3F4, U+E0062-E0063, U+E0065, U+E0067,
      U+E006C, U+E006E, U+E0073-E0074, U+E0077, U+E007F;
    src: url("${FLAG_FONT_URL}") format("truetype");
    font-display: swap;
  }`;

  targetDocument.head.appendChild(style);
  return true;
}

export const COUNTRY_FLAG_EMOJI_STACK =
  `"${FLAG_FONT_NAME}", "Apple Color Emoji", "Noto Color Emoji Flags", "Noto Color Emoji", "Segoe UI Emoji", "Twemoji Mozilla", "Segoe UI Symbol", emoji`;
